import { Component, OnInit, computed, inject, signal } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { AuthenticationService } from '@core/authentication/authentication.service';
import { APP_CONSTANTS } from '@constants';

interface BottomNavItem {
    icon: string;
    label: string;
    route: string;
    roles: string[];
}

@Component({
    selector: 'bottom-nav',
    standalone: true,
    imports: [CommonModule, RouterModule],
    templateUrl: './bottom-nav.component.html',
    styleUrls: ['./bottom-nav.component.css'],
})
export class BottomNavComponent implements OnInit {
    private authService = inject(AuthenticationService);
    private router = inject(Router);

    userRole = signal<string>('user');

    readonly allNavItems: BottomNavItem[] = [
        { icon: 'pi pi-plus-circle', label: 'New Chat', route: '/prompt', roles: ['user'] },
        { icon: 'pi pi-user', label: 'Profile', route: '/profile', roles: ['user'] },
        { icon: 'pi pi-history', label: 'History', route: '/chat-history', roles: ['user'] },
        { icon: 'pi pi-star', label: 'Plans', route: '/subscriptions/plans', roles: ['user'] },
        { icon: 'pi pi-users', label: 'Users', route: '/admin/users', roles: ['admin', 'subadmin'] },
        { icon: 'pi pi-id-card', label: 'H. Design', route: '/admin/human-design', roles: ['admin', 'subadmin'] },
        { icon: 'pi pi-sliders-h', label: 'General', route: '/admin/general', roles: ['admin', 'subadmin'] },
        { icon: 'pi pi-credit-card', label: 'Plans', route: '/admin/plans', roles: ['admin'] },
        { icon: 'pi pi-money-bill', label: 'Transactions', route: '/admin/transactions', roles: ['admin'] },
    ];

    visibleNavItems = computed<BottomNavItem[]>(() => {
        const role = this.userRole();
        const items = this.allNavItems.filter(item => item.roles.includes(role));
        return items.slice(0, 5);
    });

    ngOnInit(): void {
        try {
            const userCookie = this.authService.getCookie(APP_CONSTANTS.COOKIE_NAMES.USER);
            if (userCookie) {
                const user = JSON.parse(userCookie);
                this.userRole.set(user?.role ?? 'user');
            }
        } catch {
            this.userRole.set('user');
        }
    }

    isActive(route: string): boolean {
        return this.router.url === route || this.router.url.startsWith(route + '/');
    }
}
